import { Modal } from "antd";
import successIcon from "../../assets/images/success-icon.png";
import failedIcon from "../../assets/images/failed-icon.png"

export const modalCustom = (title, content, buttonText, okFunction, statusModal) => {
  const modalTitleLogo = (titleText, statusModalOption) => {
    return (
      <>
        <div>
          {statusModalOption === "success"
            && <img style={{ maxWidth: "50%" }} alt="success-icon" src={successIcon} />}

          {statusModalOption === "failed"
            && <img style={{ maxWidth: "50%" }} alt="failed-icon" src={failedIcon} />}
        </div>
        <div>
          {titleText}
        </div>
      </>

    )
  }
  Modal.success({
    title: modalTitleLogo(title, statusModal),
    content: content,
    okText: buttonText,
    okType: statusModal === "success" ? "success-button" : "failed-button",
    centered: true,
    icon: <></>,
    onOk() { okFunction() }
  });
}


export const modalConfirmCancel = (title, content, okayLabel, cancelLabel, okFunction) => {
  Modal.confirm({
    title: title,
    centered: true,
    okText: okayLabel,
    cancelText: cancelLabel,
    content: content,
    icon: null,
    onOk() { okFunction() }
  });
}